import styled from 'styled-components';

const CardInfo = styled.div`
    padding: 18px;
    overflow: hidden;
`

export default CardInfo;